import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const IconWrapper = styled.svg`
  width: 100%;
  height: 100%;
`;

const ChatOnPath = styled.path`
  fill: ${props => props.theme.carvana.green.primary};
`;

const ChatOffPath = styled.path`
  fill: ${props => props.theme.carvana.red.primary};
`;

const Icon = ({ iconName }) => {
  switch (iconName) {
    case 'contact':
      return (
        <IconWrapper xmlns="http://www.w3.org/2000/svg">
          <g>
            <path d="M1.65,0A1.66,1.66,0,0,0,0,1.64V21.36A1.66,1.66,0,0,0,1.65,23h34.7A1.66,1.66,0,0,0,38,21.36V1.64A1.66,1.66,0,0,0,36.35,0ZM3.06,1.64H34.94l-15.1,12.5a1.55,1.55,0,0,1-1.68,0Zm-1.41,1,11.13,9.21L1.65,20.42V2.62Zm34.7,0v17.8L25.22,11.83ZM14.07,12.91l3,2.5a3,3,0,0,0,3.8,0l3-2.5,10.93,8.45H3.14Z" />
          </g>
        </IconWrapper>
      );
    case 'phone':
      return (
        <IconWrapper viewBox="0 0 28 33" xmlns="http://www.w3.org/2000/svg">
          <g>
            <path d="M11.61,11a2.14,2.14,0,0,0-.15-1.55L8,1.14l0-.08A1.95,1.95,0,0,0,5.28.25L1.33,2.49a2.43,2.43,0,0,0-.4.28C-.14,3.79-.29,6,.5,9.29a32.23,32.23,0,0,0,3.79,9.13,44,44,0,0,0,5.58,7.25,32.52,32.52,0,0,0,8,5.94A11.08,11.08,0,0,0,22.53,33a2.66,2.66,0,0,0,1.66-.49,3.27,3.27,0,0,0,.36-.32l3-3.51h0a2.1,2.1,0,0,0-.2-2.89l-7.16-5.3A2.28,2.28,0,0,0,18.73,20a2,2,0,0,0-1.34.69l-2,2a4,4,0,0,1-1-.69s-.08-.08-.08-.12l0,0s-1-1-2.65-3.18a25.9,25.9,0,0,1-2-2.77l-.08-.12s0,0,0-.08a8.56,8.56,0,0,1-1-2l2.25-1.51A2.2,2.2,0,0,0,11.61,11Zm-1.5-.49a.31.31,0,0,1-.2.25L7.42,12.39a1,1,0,0,0-.51.73c-.12.49-.08,1.3,1.26,3.42,0,0,.08.12.12.17a29.1,29.1,0,0,0,2.14,3c1.62,2.08,2.57,3.1,2.73,3.26s.15.2.23.28a3.17,3.17,0,0,0,2.22,1.14,1.26,1.26,0,0,0,.83-.4l2.1-2.12,0,0c.07-.12.23-.12.27-.17a.39.39,0,0,1,.32.13L26.33,27a.44.44,0,0,1,0,.57l-3.05,3.55-.08.08c-.15.12-1.18.65-4.66-1.1A29.88,29.88,0,0,1,11,24.49,40.82,40.82,0,0,1,5.6,17.56,30.47,30.47,0,0,1,2,8.92C1.09,5.05,1.8,4.12,2,4S2,4,2,4L6,1.71a.4.4,0,0,1,.19,0h.12a.56.56,0,0,1,.24.17L10,10.11l0,.08A.3.3,0,0,1,10.11,10.47Z" />
          </g>
        </IconWrapper>
      );
    case 'smallPhone':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="22"
          viewBox="0 0 19 22"
        >
          <g>
            <path
              transform="translate(-341 -9)"
              fillOpacity="0"
              stroke="#fff"
              strokeMiterlimit="50"
              strokeWidth="1"
              id="539ka"
              d="M349.16 16.56c.1-.32.05-.63-.1-.93l-2.12-4.95-.03-.04c-.14-.3-.41-.5-.73-.59-.31-.1-.66-.05-.92.1l-2.44 1.34c-.07.05-.17.1-.25.17-.65.6-.75 1.9-.26 3.9.41 1.78 1.29 3.78 2.34 5.46a25.94 25.94 0 0 0 3.43 4.34 20 20 0 0 0 4.95 3.56 7 7 0 0 0 2.86.83c.41 0 .75-.1 1.02-.3a2 2 0 0 0 .22-.19l1.83-2.1c.44-.5.39-1.29-.12-1.73l-4.42-3.16c-.24-.2-.56-.3-.87-.3-.32.03-.61.17-.83.42l-1.22 1.2c-.1-.03-.27-.15-.61-.42-.03-.03-.05-.05-.05-.08l-.02-.02s-.59-.59-1.64-1.9a15.99 15.99 0 0 1-1.24-1.66l-.05-.07c0-.03-.02-.03-.02-.05a5.07 5.07 0 0 1-.64-1.2l1.4-.9c.23-.17.45-.44.53-.73"
            />
          </g>
        </svg>
      );
    case 'faq':
      return (
        <IconWrapper xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 31">
          <g>
            <path d="M15.49,7.41a2,2,0,1,0,2,2A2,2,0,0,0,15.49,7.41Z" />
            <polygon points="13.7 13.78 13.7 23.59 17.28 23.59 17.28 23.59 17.28 13.78 13.7 13.78" />
            <path d="M15.5,2A13.5,13.5,0,1,1,2,15.5,13.52,13.52,0,0,1,15.5,2m0-2A15.5,15.5,0,1,0,31,15.5,15.5,15.5,0,0,0,15.5,0Z" />
          </g>
        </IconWrapper>
      );
    case 'chat':
      return (
        <IconWrapper xmlns="http://www.w3.org/2000/svg">
          <g>
            <path d="M21.46,8H15.63V4.94a2.89,2.89,0,0,1,2.78-3H35.23a2.92,2.92,0,0,1,2.92,3V15.09a3,3,0,0,1-2.92,3.1H34.17a.94.94,0,0,0-.92,1,.45.45,0,0,0,.13.28l.26,1.69-2.91-2.82a.76.76,0,0,0-.53-.14H26.09V13.12A4.89,4.89,0,0,0,21.46,8ZM13.77,8H4.64A4.89,4.89,0,0,0,0,13.12V23.27a4.75,4.75,0,0,0,4.5,4.94l-.79,3.52A1.23,1.23,0,0,0,4.5,33a1.37,1.37,0,0,0,.8-.28l4.77-4.51H21.46a4.86,4.86,0,0,0,4.63-4.94v-3.1H29.8l4.77,4.37a.79.79,0,0,0,.93.28,1.07,1.07,0,0,0,.66-1.13l-.8-3.52A5.08,5.08,0,0,0,40,15.09V4.94A4.88,4.88,0,0,0,35.23,0H18.41a4.86,4.86,0,0,0-4.64,4.94ZM4.64,10H21.46a2.93,2.93,0,0,1,2.78,3.11V23.27a2.81,2.81,0,0,1-2.78,3H9.67a1,1,0,0,0-.53.28L6.23,29.19l.39-1.69v-.28a.93.93,0,0,0-.92-1H4.64a2.81,2.81,0,0,1-2.79-3V13.12A2.94,2.94,0,0,1,4.64,10Z" />
          </g>
        </IconWrapper>
      );
    case 'chatOn':
      return (
        <IconWrapper viewBox="0 0 44 40" xmlns="http://www.w3.org/2000/svg">
          <g>
            <ChatOnPath d="M38,0a6,6,0,1,0,6,6A6,6,0,0,0,38,0Zm3.14,4.15L37.28,9.21,35.1,7a.86.86,0,0,1-.23-.59.87.87,0,0,1,.26-.59.81.81,0,0,1,.57-.23h0a.83.83,0,0,1,.59.25l.82.86,2.69-3.51a.8.8,0,0,1,.55-.32A.78.78,0,0,1,41,3a.79.79,0,0,1,.32.56A.79.79,0,0,1,41.14,4.15Z" />
            <path d="M38.15,19.09a3,3,0,0,1-2.92,3.1H34.17a.94.94,0,0,0-.92,1,.45.45,0,0,0,.13.28l.26,1.69-2.91-2.82a.76.76,0,0,0-.53-.14H26.09V17.12A4.89,4.89,0,0,0,21.46,12H15.63V8.94a2.89,2.89,0,0,1,2.78-3H30a8,8,0,0,1,.26-2H18.41a4.86,4.86,0,0,0-4.64,4.94V12H4.64A4.89,4.89,0,0,0,0,17.12V27.27a4.75,4.75,0,0,0,4.5,4.94l-.79,3.52A1.23,1.23,0,0,0,4.5,37a1.37,1.37,0,0,0,.8-.28l4.77-4.51H21.46a4.86,4.86,0,0,0,4.63-4.94v-3.1H29.8l4.77,4.37a.79.79,0,0,0,.93.28,1.07,1.07,0,0,0,.66-1.13l-.8-3.52A5.08,5.08,0,0,0,40,19.09V13.74a8.09,8.09,0,0,1-1.85.25ZM24.24,27.27a2.81,2.81,0,0,1-2.78,3H9.67a1,1,0,0,0-.53.28L6.23,33.19l.39-1.69v-.28a.93.93,0,0,0-.92-1H4.64a2.81,2.81,0,0,1-2.79-3V17.12A2.94,2.94,0,0,1,4.64,14H21.46a2.93,2.93,0,0,1,2.78,3.11Z" />
          </g>
        </IconWrapper>
      );
    case 'chatOff':
      return (
        <IconWrapper viewBox="0 0 44 40" xmlns="http://www.w3.org/2000/svg">
          <g>
            <ChatOffPath d="M38,0a6,6,0,1,0,6,6A6,6,0,0,0,38,0Zm2.65,7.59a.75.75,0,0,1,0,1.06.75.75,0,0,1-1.06,0L38,7.06,36.41,8.65a.75.75,0,0,1-1.06,0,.75.75,0,0,1,0-1.06L36.94,6,35.35,4.41a.75.75,0,1,1,1.06-1.06L38,4.94l1.59-1.59a.75.75,0,1,1,1.06,1.06L39.06,6Z" />
            <path d="M38.15,19.09a3,3,0,0,1-2.92,3.1H34.17a.94.94,0,0,0-.92,1,.45.45,0,0,0,.13.28l.26,1.69-2.91-2.82a.76.76,0,0,0-.53-.14H26.09V17.12A4.89,4.89,0,0,0,21.46,12H15.63V8.94a2.89,2.89,0,0,1,2.78-3H30a8,8,0,0,1,.26-2H18.41a4.86,4.86,0,0,0-4.64,4.94V12H4.64A4.89,4.89,0,0,0,0,17.12V27.27a4.75,4.75,0,0,0,4.5,4.94l-.79,3.52A1.23,1.23,0,0,0,4.5,37a1.37,1.37,0,0,0,.8-.28l4.77-4.51H21.46a4.86,4.86,0,0,0,4.63-4.94v-3.1H29.8l4.77,4.37a.79.79,0,0,0,.93.28,1.07,1.07,0,0,0,.66-1.13l-.8-3.52A5.08,5.08,0,0,0,40,19.09V13.74a8.09,8.09,0,0,1-1.85.25ZM24.24,27.27a2.81,2.81,0,0,1-2.78,3H9.67a1,1,0,0,0-.53.28L6.23,33.19l.39-1.69v-.28a.93.93,0,0,0-.92-1H4.64a2.81,2.81,0,0,1-2.79-3V17.12A2.94,2.94,0,0,1,4.64,14H21.46a2.93,2.93,0,0,1,2.78,3.11Z" />
          </g>
        </IconWrapper>
      );
    case 'check':
      return (
        <IconWrapper
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="10"
          viewBox="0 0 12 10"
        >
          <g id="check-12x10-blue">
            <path d="M4.14,10,.37,6.1a1.36,1.36,0,0,1,0-1.85,1.21,1.21,0,0,1,1.77,0l2,2.08L9.87.38a1.21,1.21,0,0,1,1.77,0,1.35,1.35,0,0,1,0,1.84Z" />
          </g>
        </IconWrapper>
      );
    case 'close':
      return (
        <IconWrapper xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
          <g>
            <path d="M5.71,5,9.85.85a.48.48,0,0,0,0-.7.48.48,0,0,0-.7,0L5,4.29.85.15a.48.48,0,0,0-.7,0,.48.48,0,0,0,0,.7L4.29,5,.15,9.15a.48.48,0,0,0,0,.7A.47.47,0,0,0,.5,10a.47.47,0,0,0,.35-.15L5,5.71,9.15,9.85a.48.48,0,0,0,.7,0,.48.48,0,0,0,0-.7Z" />
          </g>
        </IconWrapper>
      );
    case 'favorite':
      return (
        <IconWrapper xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18">
          <g>
            <path d="M20.2 1.48a5.82 5.82 0 0 0-7.75 0L11 2.82 9.55 1.48a5.82 5.82 0 0 0-7.75 0 5.39 5.39 0 0 0 0 8L11 18l9.2-8.48a5.39 5.39 0 0 0 0-8.04z" />
          </g>
        </IconWrapper>
      );
    case 'profile':
      return (
        <IconWrapper xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20">
          <g>
            <path d="M22,11A11,11,0,1,0,4,19.49v-.16A5.35,5.35,0,0,1,8.77,14a4.33,4.33,0,1,1,4.46,0A5.35,5.35,0,0,1,18,19.33v.16A11,11,0,0,0,22,11Z" />
          </g>
        </IconWrapper>
      );
    case 'hamburger':
      return (
        <IconWrapper xmlns="http://www.w3.org/2000/svg">
          <g>
            <path d="M0,12H20V10H0ZM0,7H20V5H0ZM0,0V2H20V0Z" />
          </g>
        </IconWrapper>
      );
    case 'dropdownArrow':
      return (
        <IconWrapper xmlns="http://www.w3.org/2000/svg">
          <g>
            <path d="M0,0H9L4.5,5Z" />
          </g>
        </IconWrapper>
      );
    case 'arrowUp':
      return (
        <IconWrapper
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="6"
          viewBox="0 0 10 6"
        >
          <g id="arrow-up-10x6-blue">
            <path d="M0,5.19a.8.8,0,0,1,.23-.55L4.52.26A.9.9,0,0,1,5.16,0a.92.92,0,0,1,.63.28l4,4.38A.77.77,0,0,1,9.7,5.8a.87.87,0,0,1-1.2-.08L5.12,2,1.48,5.74a.88.88,0,0,1-1.21,0A.78.78,0,0,1,0,5.19" />
          </g>
        </IconWrapper>
      );
    case 'arrowDown':
      return (
        <IconWrapper
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="6"
          viewBox="0 0 10 6"
        >
          <g id="arrow-down-10x6-blue">
            <path d="M0,.81a.78.78,0,0,0,.23.55L4.52,5.74A.9.9,0,0,0,5.16,6a.88.88,0,0,0,.63-.28l4-4.38A.77.77,0,0,0,9.71.2a.88.88,0,0,0-1.2.08L5.13,4,1.48.26A.88.88,0,0,0,.27.22.78.78,0,0,0,0,.81" />
          </g>
        </IconWrapper>
      );
    case 'arrowRight':
      return (
        <IconWrapper xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6">
          <g id="dropdown-arrow-right" transform="rotate(270, 5, 3)">
            <path d="M0,0H9L4.5,5Z" />
          </g>
        </IconWrapper>
      );
    case 'blueArrowRight':
      return (
        <IconWrapper
          xmlns="http://www.w3.org/2000/svg"
          width="6"
          height="10"
          viewBox="0 0 6 10"
        >
          <g id="arrow-forward-6x10-blue">
            <path
              d="M.81,10a.74.74,0,0,0,.55-.23L5.74,5.48A.89.89,0,0,0,6,4.84a.84.84,0,0,0-.28-.63L1.34.21A.77.77,0,0,0,.2.3.88.88,0,0,0,.28,1.5L4,4.88.26,8.52a.88.88,0,0,0,0,1.21A.78.78,0,0,0,.81,10"
              fill="#00aed9"
            />
          </g>
        </IconWrapper>
      );
    case 'carvanaLogo':
      return (
        <IconWrapper xmlns="http://www.w3.org/2000/svg" viewBox="0 0 153 35">
          <g>
            <path
              d="M95.82,20.11l-3.94-10H88.47l.19.46,5.83,14.13h2.58l6-14.59H99.74l-3.92,10M131.28,19l-6.89-8.91h-2.75V24.56h3.08V15.37l7.11,9.19h2.53V10.07h-3.08ZM109.6,10l-6.37,14.59h3.18l2.64-6.15h0L110.91,14v0l0-.07,1.71,4.11-1.17,2.68h2.29l.81,1.94.77,1.84h3.3L112.29,10Zm37,0h-2.7l-6.37,14.59h3.18l2.64-6.15h0l1.85-4.33h0l.05-.1,1.71,4.1-1.17,2.7h2.3l.81,1.94.77,1.84H153Z"
              fill="#183558"
            />
            <path
              d="M52.78,21.4a8,8,0,0,1-2,1.52,5.53,5.53,0,0,1-2.64.6A5.44,5.44,0,0,1,45.82,23,5.58,5.58,0,0,1,44,21.71a6.13,6.13,0,0,1-1.23-2,6.61,6.61,0,0,1-.44-2.41v0a6.6,6.6,0,0,1,.44-2.4,6.18,6.18,0,0,1,1.22-2,5.61,5.61,0,0,1,1.83-1.32,5.45,5.45,0,0,1,2.3-.49,6.74,6.74,0,0,1,1.49.16,6,6,0,0,1,1.22.43,5.16,5.16,0,0,1,1,.63,11.09,11.09,0,0,1,.89.76l.25.23.94-1-.25-.23c-.35-.32-.71-.62-1.07-.89a6.9,6.9,0,0,0-1.21-.72A6.77,6.77,0,0,0,49.91,10a8.31,8.31,0,0,0-1.8-.18,6.73,6.73,0,0,0-2.88.61A6.93,6.93,0,0,0,43,12.06a7.29,7.29,0,0,0-1.48,2.38A7.86,7.86,0,0,0,41,17.31v0a8,8,0,0,0,.53,2.9A7.1,7.1,0,0,0,43,22.61a7.26,7.26,0,0,0,2.25,1.6,6.94,6.94,0,0,0,2.84.59,7.61,7.61,0,0,0,1.77-.2,8,8,0,0,0,1.52-.52,7.53,7.53,0,0,0,1.29-.79,11.16,11.16,0,0,0,1.09-1l.24-.24L53,21.17l-.24.23M63.47,10,56.6,24.56H58L64,11.88,67.37,19l-.85,1.81h1.71L70,24.56h1.36L64.52,10h-1M81.83,18.5a6.09,6.09,0,0,0,1.24-.32,4.83,4.83,0,0,0,1.49-.85,3.7,3.7,0,0,0,1-1.3,4.1,4.1,0,0,0,.35-1.7v0a4.19,4.19,0,0,0-.29-1.55,4,4,0,0,0-.81-1.25A4.76,4.76,0,0,0,83,10.43a7.57,7.57,0,0,0-2.43-.36h-6V24.56H75.9v-5.9h4.39l4.5,5.9h1.7L81.83,18.5M75.9,17.38v-6h4.66a4.79,4.79,0,0,1,3,.81,2.57,2.57,0,0,1,1,2.17v0a2.78,2.78,0,0,1-.26,1.2,2.68,2.68,0,0,1-.78.94,3.88,3.88,0,0,1-1.29.63,6.38,6.38,0,0,1-1.8.24H75.9"
              fill="#183558"
            />
            <path
              d="M34.63,17.32A17.32,17.32,0,1,1,17.31,0,17.31,17.31,0,0,1,34.63,17.32Z"
              fill="#00acd8"
            />
            <path
              d="M17.4,8.84a19.38,19.38,0,0,0-2.88.2,4.5,4.5,0,0,0-1.29.35l.08,0a4.34,4.34,0,0,0,.91.26,18.19,18.19,0,0,0,3.18.25,18.07,18.07,0,0,0,2.87-.2,4.69,4.69,0,0,0,1.29-.34l-.08,0a4.4,4.4,0,0,0-.9-.26,18.37,18.37,0,0,0-3.18-.25m0,1.76a19.32,19.32,0,0,1-3-.21,3.79,3.79,0,0,1-1.76-.58.67.67,0,0,1-.2-.42.64.64,0,0,1,.2-.42A1.38,1.38,0,0,1,13,8.74a5.07,5.07,0,0,1,1.06-.3,18,18,0,0,1,3.31-.26,19.4,19.4,0,0,1,3,.2A3.58,3.58,0,0,1,22.11,9a.57.57,0,0,1,.21.42.59.59,0,0,1-.21.42,1.38,1.38,0,0,1-.35.22,4.85,4.85,0,0,1-1.06.31,18.85,18.85,0,0,1-3.3.26"
              fill="#fbb649"
            />
            <path
              d="M24.92,17.66a12.2,12.2,0,0,1-1-1.49l.08,0s1.85-.1,1.52-.74c0,0-.36-.77-1.72-.77h-.19c-.06,0-.15,0-.18.5a6.48,6.48,0,0,0-1.91-2.53,1.94,1.94,0,0,0-.64-.22c-.39-.07-3.34-.1-3.58-.1h0c-.24,0-3.19,0-3.58.1a1.85,1.85,0,0,0-.64.22,6.48,6.48,0,0,0-1.91,2.53c0-.47-.12-.5-.19-.5h-.18c-1.36,0-1.72.77-1.72.77-.33.64,1.52.74,1.52.74l.08,0a12.2,12.2,0,0,1-1,1.49,4.22,4.22,0,0,0-.53.77,2.41,2.41,0,0,0-.14.88c0,.49.07,2.63.07,2.63v2.69a.25.25,0,0,0,.22.28h2.13a.25.25,0,0,0,.23-.28V24.3H22.94v.33a.25.25,0,0,0,.23.28h2.12a.25.25,0,0,0,.23-.28V21.94s.05-2.14.07-2.63a2.11,2.11,0,0,0-.15-.88A3.82,3.82,0,0,0,24.92,17.66ZM12,15.6A14.73,14.73,0,0,1,13.42,13s1.21-.06,2.82-.07l0,.12v.28a.19.19,0,0,0,.19.19h1.87a.19.19,0,0,0,.2-.19v-.28l-.05-.12c1.61,0,2.81.07,2.81.07a15,15,0,0,1,1.47,2.59c.11.3-.14.3-.14.3H12.09S11.84,15.9,12,15.6ZM10,20c-.41-.1-.45-.35-.45-.35a2.32,2.32,0,0,1,.13-1.07.67.67,0,0,1,.74-.39,4.71,4.71,0,0,1,1.21.58c.7.36.79,1.59.79,1.59A20.78,20.78,0,0,1,10,20Zm11.47.43c-1.25.1-3.05.11-4.14.11s-2.89,0-4.14-.11c0,0-.35-.76.19-.78.07,0,1.68-.06,4-.06s3.88.06,3.95.06C21.81,19.71,21.46,20.47,21.46,20.47Zm3.64-.78s-.05.25-.45.35a21,21,0,0,1-2.43.36s.1-1.23.79-1.59a4.88,4.88,0,0,1,1.21-.58.69.69,0,0,1,.75.39A2.49,2.49,0,0,1,25.1,19.69Z"
              fill="#fff"
            />
          </g>
        </IconWrapper>
      );
    case 'playButton':
      return (
        <IconWrapper viewBox="0 0 115 115">
          <g>
            <circle
              cx="57.5"
              cy="57.5"
              r="57.5"
              transform="translate(-2.79 2.94) rotate(-2.86)"
            />
            <path d="M72,58.35c-1.12.67-19.5,11.36-20.83,12.1A1.42,1.42,0,0,1,49,69.16V45a1.44,1.44,0,0,1,2.22-1.3c.92.52,19.18,11.16,20.75,12.07A1.5,1.5,0,0,1,72,58.35Z" />
          </g>
        </IconWrapper>
      );
    case 'questionMark':
      return (
        <IconWrapper
          xmlns="http://www.w3.org/2000/svg"
          width="23px"
          height="23px"
          viewBox="-1 -1 25 25"
        >
          <defs>
            <path
              id="zypza"
              d="M1313.5 3484a11.5 11.5 0 1 1 0 23 11.5 11.5 0 0 1 0-23z"
            />
            <path
              id="zypzc"
              d="M1317 3493.57a3.54 3.54 0 0 1-2.5 3.4v1h-2v-2.87h1a1.53 1.53 0 0 0 0-3.06c-.82 0-1.5.7-1.5 1.53h-2a3.55 3.55 0 0 1 3.5-3.57c1.92 0 3.5 1.61 3.5 3.57zm-4.5 5.71h1.97v1.72h-1.97z"
            />
            <clipPath strokeWidth="0" id="zypzb">
              <use xlinkHref="#zypza" />
            </clipPath>
          </defs>
          <g>
            <g transform="translate(-1302 -3484)">
              <use fillOpacity="0" xlinkHref="#zypza" />
              <use
                fillOpacity="0"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                strokeMiterlimit="50"
                clipPath='url("#zypzb")'
                xlinkHref="#zypza"
              />
            </g>
            <g transform="translate(-1302 -3484)">
              <use xlinkHref="#zypzc" strokeWidth="0" />
            </g>
          </g>
        </IconWrapper>
      );
    case 'bell':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8.48391" cy="7.61916" r="6.09524" fill="white" />
          <rect
            x="2.38867"
            y="6.85693"
            width="12.1905"
            height="4.57143"
            fill="white"
          />
          <circle cx="8.48426" cy="2.28571" r="2.28571" fill="white" />
          <circle cx="8.48426" cy="13.7144" r="2.28571" fill="white" />
          <path
            d="M15.7224 13.3334H0.865234C0.865234 12.0636 2.08428 9.52393 8.48428 9.52393C14.8843 9.52393 16.1033 12.0636 15.7224 13.3334Z"
            fill="white"
          />
        </svg>
      );
    case 'warning':
      return (
        <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="path-1-inside-1" fill="white">
            <path fillRule="evenodd" clipRule="evenodd" d="M24.9401 6.6959L2.19542 43.0874C1.67507 43.92 2.27362 44.9999 3.25542 44.9999H48.7448C49.7266 44.9999 50.3251 43.92 49.8048 43.0874L27.0601 6.6959C26.5705 5.91256 25.4297 5.91257 24.9401 6.6959ZM26.3643 30.8799H25.6443C25.4418 30.8799 25.2393 30.6999 25.2168 30.5199L24.3393 24.2424V21.6774C24.3393 21.4524 24.5418 21.2499 24.7668 21.2499H27.2418C27.4668 21.2499 27.6693 21.4524 27.6693 21.6774V24.1974L26.7918 30.5199C26.7693 30.6999 26.5668 30.8799 26.3643 30.8799ZM25.9818 37.2249C24.9918 37.2249 24.1593 36.3924 24.1593 35.3799C24.1593 34.3674 24.9918 33.5124 25.9818 33.5124C27.0168 33.5124 27.8493 34.3674 27.8493 35.3799C27.8493 36.3924 27.0168 37.2249 25.9818 37.2249Z" />
          </mask>
          <path fillRule="evenodd" clipRule="evenodd" d="M24.9401 6.6959L2.19542 43.0874C1.67507 43.92 2.27362 44.9999 3.25542 44.9999H48.7448C49.7266 44.9999 50.3251 43.92 49.8048 43.0874L27.0601 6.6959C26.5705 5.91256 25.4297 5.91257 24.9401 6.6959ZM26.3643 30.8799H25.6443C25.4418 30.8799 25.2393 30.6999 25.2168 30.5199L24.3393 24.2424V21.6774C24.3393 21.4524 24.5418 21.2499 24.7668 21.2499H27.2418C27.4668 21.2499 27.6693 21.4524 27.6693 21.6774V24.1974L26.7918 30.5199C26.7693 30.6999 26.5668 30.8799 26.3643 30.8799ZM25.9818 37.2249C24.9918 37.2249 24.1593 36.3924 24.1593 35.3799C24.1593 34.3674 24.9918 33.5124 25.9818 33.5124C27.0168 33.5124 27.8493 34.3674 27.8493 35.3799C27.8493 36.3924 27.0168 37.2249 25.9818 37.2249Z" fill="#FEB948" />
          <path d="M2.19542 43.0874L0.499422 42.0274H0.499421L2.19542 43.0874ZM24.9401 6.6959L26.6361 7.7559V7.7559L24.9401 6.6959ZM49.8048 43.0874L48.1088 44.1474L49.8048 43.0874ZM27.0601 6.6959L28.7561 5.6359L28.7561 5.6359L27.0601 6.6959ZM25.2168 30.5199L27.2014 30.2718L27.1996 30.2574L27.1976 30.243L25.2168 30.5199ZM24.3393 24.2424H22.3393V24.3815L22.3586 24.5193L24.3393 24.2424ZM27.6693 24.1974L29.6503 24.4723L29.6693 24.3355V24.1974H27.6693ZM26.7918 30.5199L24.8108 30.245L24.809 30.2584L24.8073 30.2718L26.7918 30.5199ZM3.89142 44.1474L26.6361 7.7559L23.2441 5.6359L0.499422 42.0274L3.89142 44.1474ZM3.25542 42.9999C3.84449 42.9999 4.20362 43.6479 3.89142 44.1474L0.499421 42.0274C-0.853487 44.1921 0.702752 46.9999 3.25542 46.9999V42.9999ZM48.7448 42.9999H3.25542V46.9999H48.7448V42.9999ZM48.1088 44.1474C47.7966 43.6479 48.1557 42.9999 48.7448 42.9999V46.9999C51.2975 46.9999 52.8537 44.1921 51.5008 42.0274L48.1088 44.1474ZM25.3641 7.7559L48.1088 44.1474L51.5008 42.0274L28.7561 5.6359L25.3641 7.7559ZM26.6361 7.7559C26.3424 8.2259 25.6579 8.2259 25.3641 7.7559L28.7561 5.6359C27.4832 3.59923 24.517 3.59923 23.2441 5.6359L26.6361 7.7559ZM25.6443 32.8799H26.3643V28.8799H25.6443V32.8799ZM23.2323 30.768C23.3209 31.4772 23.7136 31.9877 24.0615 32.2859C24.4205 32.5937 24.9675 32.8799 25.6443 32.8799V28.8799C26.1186 28.8799 26.4631 29.0761 26.6647 29.2489C26.8551 29.4121 27.1352 29.7426 27.2014 30.2718L23.2323 30.768ZM22.3586 24.5193L23.2361 30.7968L27.1976 30.243L26.3201 23.9655L22.3586 24.5193ZM22.3393 21.6774V24.2424H26.3393V21.6774H22.3393ZM24.7668 19.2499C23.4373 19.2499 22.3393 20.3478 22.3393 21.6774H26.3393C26.3393 22.1667 26.1255 22.5509 25.8829 22.7935C25.6403 23.0361 25.2562 23.2499 24.7668 23.2499V19.2499ZM27.2418 19.2499H24.7668V23.2499H27.2418V19.2499ZM29.6693 21.6774C29.6693 20.3478 28.5714 19.2499 27.2418 19.2499V23.2499C26.7525 23.2499 26.3684 23.0361 26.1257 22.7935C25.8831 22.5509 25.6693 22.1667 25.6693 21.6774H29.6693ZM29.6693 24.1974V21.6774H25.6693V24.1974H29.6693ZM28.7728 30.7948L29.6503 24.4723L25.6883 23.9225L24.8108 30.245L28.7728 30.7948ZM26.3643 32.8799C27.0411 32.8799 27.5881 32.5937 27.9472 32.2859C28.2951 31.9877 28.6877 31.4772 28.7764 30.768L24.8073 30.2718C24.8734 29.7426 25.1536 29.4121 25.344 29.2489C25.5455 29.0761 25.89 28.8799 26.3643 28.8799V32.8799ZM22.1593 35.3799C22.1593 37.481 23.8714 39.2249 25.9818 39.2249V35.2249C26.0572 35.2249 26.1027 35.2569 26.1195 35.2739C26.1372 35.2917 26.1593 35.3284 26.1593 35.3799H22.1593ZM25.9818 31.5124C23.8402 31.5124 22.1593 33.3105 22.1593 35.3799H26.1593C26.1593 35.4277 26.1404 35.4534 26.1312 35.4628C26.1217 35.4726 26.0742 35.5124 25.9818 35.5124V31.5124ZM29.8493 35.3799C29.8493 33.2785 28.137 31.5124 25.9818 31.5124V35.5124C25.9355 35.5124 25.8997 35.491 25.8836 35.4748C25.8699 35.461 25.8493 35.4293 25.8493 35.3799H29.8493ZM25.9818 39.2249C28.1056 39.2249 29.8493 37.5127 29.8493 35.3799H25.8493C25.8493 35.2721 25.9281 35.2249 25.9818 35.2249V39.2249Z" fill="#FEB948" mask="url(#path-1-inside-1)" />
        </svg>
      );
    default:
      return '';
  }
};

Icon.propTypes = {
  iconName: PropTypes.string.isRequired,
};

export default Icon;
